/**
 * Creation confirm card. Shown at creation moments (after AI drafts, after a
 * template, on blank/import).
 *
 * Was `CreateModeChoice` — a Flow-vs-Block radio pair. Block was gated off the
 * web build on 2026-07-19, which left a radiogroup with exactly one radio still
 * asking "How do you want to open it?", and removed outright on 2026-09-06. A
 * question with one answer is worse than no question, so the card is now what
 * it always did: confirm, and open.
 *
 * `data-testid="create-mode-confirm"` is deliberately unchanged — it is the
 * confirm contract for e2e specs, and renaming it would churn them for nothing.
 */

interface CreateConfirmProps {
  /** Fires when the author confirms. */
  onConfirm: () => void;
  /** Optional context line above the button. */
  heading?: string;
  className?: string;
  /** Disable confirm while create/import is in flight. */
  disabled?: boolean;
  /** Override the button label. */
  confirmLabel?: string;
}

export function CreateConfirm({
  onConfirm,
  heading,
  className,
  disabled = false,
  confirmLabel,
}: CreateConfirmProps) {
  return (
    <div className={className} style={{ width: "100%" }}>
      {heading && (
        <p style={{ margin: "0 0 10px", fontSize: 13, color: "var(--lilia-text-secondary)" }}>{heading}</p>
      )}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 12 }}>
        <button
          data-testid="create-mode-confirm"
          type="button"
          disabled={disabled}
          onClick={onConfirm}
          style={{
            fontSize: 13, fontWeight: 700, color: "#fff", background: "var(--lilia-primary)",
            border: 0, borderRadius: 9, padding: "8px 16px",
            cursor: disabled ? "not-allowed" : "pointer",
            whiteSpace: "nowrap",
            opacity: disabled ? 0.6 : 1,
          }}
        >
          {confirmLabel ?? "Open"}
        </button>
      </div>
    </div>
  );
}
